<template>
    <form>
        <h3>Section Two - Student Details</h3>
        <label><span>First Names</span><input required name="firstnames" v-model="$parent.rec.firstnames"></label>
        <label><span>Last Name</span><input required name="lastname" v-model="$parent.rec.lastname"></label>
        <RadioSet :options="opGen" prompt="Gender" name="gender" v-model="$parent.rec.gender"/>
        <label><span>DOB</span><input name="dob" type="date" required v-model="$parent.rec.dob"></label>
        <label><span>Mobile Phone</span><input required name="mobilephone" v-model="$parent.rec.mobilephone"></label>
        <label><span>Home Phone</span><input name="homephone" placeholder="Optional" v-model="$parent.rec.homephone"></label>
        <label><span>Address</span><input required name="address" placeholder="Street Number and Name" v-model="$parent.rec.address"></label>
        <label><span>Suburb</span><input required name="suburb" v-model="$parent.rec.suburb"></label>
        <label><span>Town/City</span><input required name="city" v-model="$parent.rec.city"></label>
        <label><span>Postcode</span><input name="postcode" placeholder="Optional" v-model="$parent.rec.postcode"></label>
        <label><span>Email</span><input required name="email" type="email" v-model="$parent.rec.email"></label>
        <label><span>Instagram Handle</span><input name="instagram" placeholder="Optional" v-model="$parent.rec.instagram"></label>
        <label><span>TikTok Username</span><input name="tiktok" placeholder="Optional" v-model="$parent.rec.tiktok"></label>
        <footer><button @click.prevent="$parent.prevTab">Back</button><button @click.prevent="$parent.nextTab">Next</button></footer>
    </form>
</template>

<script>
import RadioSet from '@/components/radio-set.vue'
export default {
    name:"section 2",
    components:{RadioSet},
    data: function (){return {
        opGen: ["Male","Female","Another Gender"]
    }},
    methods:{
        allGood: function(){
            let notfilled = [
                "firstnames",
                "lastname",
                "gender",
                "dob",
                "mobilephone",
                "address",
                "suburb",
                "city",
                "email"].map(u=>this.$parent.rec[u]).filter(u=>u=="");
            if (notfilled.length==0)
                return true;
            return false;
        }
    }
}
</script>

<style>
</style>